function PaymentLoader() {
  return (
    <section>
      <div id="preloader" className="no-bg">
        <div id="ctn-preloader" className="ctn-preloader loader-bg">
          <div className="animation-preloader">
            <img src="/files/img/logo-dark-old.png" className="loaderimg" alt="loader"/>
            <div className="spinner"></div>
            <span>Please Wait...
              <br></br>
              <small>Please do not close or refresh the page.</small>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PaymentLoader;
